import { PolIcon } from "components/PolIcon/policon";
import React from 'react';
import { useFrontContext } from "v4/contexts/FrontContext";
import SecondaryNavigationItem from "v4/features/front/navigation/components/SecondaryNavigation/SecondaryNavigationItem";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import './SecondaryNavigation.scss';

export default function SecondaryNavigation() {
    const { detailNavigation, currentRoute } = useNavigation();
    const { goBackToListing } = useFrontContext();

    if (!currentRoute) return null;

    return (
        <ul className="prospect__tab__navigation">
            {detailNavigation.filter(item => item.label).map(item => (
                <SecondaryNavigationItem
                    key={item.url + item.metadata.id}
                    item={item}
                    currentRoute={currentRoute}
                />
            ))}
            <li className="tab-close" onClick={goBackToListing}>
                <PolIcon icon="close"/>
            </li>
        </ul>
    );
}
